import {Util} from 'yougile-util'

export const getShortedPath = (fullPath: string): string => {
  const arrayOfIds = fullPath.split('/')
  const arrayOfNewPath: string[] = []

  for (const id of arrayOfIds) {
    if (Util.isUUID(id)) {
      arrayOfNewPath.push(getShortedId(id))
    } else {
      arrayOfNewPath.push(id)
    }
  }

  return arrayOfNewPath.join('/')
}

export const getShortedId = (id: string): string => {
  if (Util.isUUID(id)) {
    return id.split('-').pop() || ''
  }

  return id
}
